import { render, staticRenderFns } from "./historical-version.vue?vue&type=template&id=388fc8b4&scoped=true&"
import script from "./historical-version.vue?vue&type=script&lang=ts&"
export * from "./historical-version.vue?vue&type=script&lang=ts&"
import style0 from "./historical-version.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./historical-version.vue?vue&type=style&index=1&id=388fc8b4&lang=scss&scoped=true&"
import style2 from "./historical-version.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388fc8b4",
  null
  
)

export default component.exports